import ResourceService from "./resource.service";

class BlanketOrderService extends ResourceService {
  static get resource() {
    return "blanket-order";
  }
}

export default BlanketOrderService;